<template>
  <div class="article-2">
    <div class="article__info">
      <h1 class="article__title">藍綠母雞誰強？</h1>
      <h2 class="article__subtitle">能帶領小雞進國會殿堂</h2>
      <div class="article__reporter">聯合報 記者：蔡晉宇、鄭媁、張文馨／報導</div>
    </div>

    <figure class="article__figure article__cover">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-2-cover.jpg')})`"></div>
      <figcaption class="article__figure-caption">
        <span>2020總統大選，民進黨由總統蔡英文角逐連任，國民黨由高雄市長韓國瑜參選。兩人在競選造勢大會上與黨內要角同台拉抬聲勢。記者黃義書、許正宏／攝影。</span>
      </figcaption>
    </figure>

    <p class="article__paragraph">總統和立委選舉一起投票，在同一選區得票率高低，經過統計分析，兩者之間確實存在關連性，也就是一般常聽到的「母雞帶小雞」效應。一位強大的母雞往往能夠神助攻，反之，母雞體質不佳，可能會淪為隊友的拖油瓶。</p>
    <p class="article__paragraph">統計中選會公布的2016年總統大選得票資料，結果顯示，國民黨提名的朱立倫所獲得「總統得票率」，與國民黨立委候選人在各選區獲得的「區域立委得票率」，相關係數達0.575；民進黨提名的蔡英文與民進黨區域候選人的得票率，相關係數為0.599，略高於國民黨。</p>
    <p class="article__paragraph">世新大學行管系教授 <Dictionary word="莊文忠" meaning="國立政治大學博士，現任世新大學行政管理系教授，台灣透明組織協會理事，以及中華組織發展協會理事。研究領域為公共政策分析、研究方法、政府績效管理、民意調查。" /> 表示，統計學上，接近0.6的相關係數已經非常高，代表兩者顯著相關，這結果證明存在「母雞帶小雞」效應，總統候選人的強或弱，確實對區域立委候選人的得票率造成影響。</p>
    <p class="article__paragraph">再進一步分析，若要觀察「母雞」強弱，也就是在該選區發揮的效果，可從「總統得票率」減去「區域立委得票率」來判斷。若數值為「正」，表示該選區「母雞較強」；相反地，若數值為「負」，代表區域立委得票超越母雞，能解讀為「母雞較弱」，也可視為「小雞」能自立自強。</p>

    <figure class="article__figure">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-2-photo-1.jpg')})`"></div>
      <figcaption class="article__figure-caption">
        <span>民進黨總統候選人蔡英文（左）到台中替黨籍立委候選人何欣純輔選。記者黃寅／攝影</span>
      </figcaption>
    </figure>

    <h3 class="article__paragraph-title">民進黨立委靠總統 國民黨立委靠自己</h3>

    <p class="article__paragraph">例如，蔡英文於2016年扮演「強勢」母雞的角色，全國73個區域立委選區中，民進黨在13個選區沒有提名，提名的60個選區中，有56個選區的總統得票率高於民進黨區域候選人，帶動選情，最後成功拿下49席的區域立委。</p>
    <p class="article__paragraph">不過，有些夠強壯的小雞，是靠自身實力、不靠蔡英文，像台東立委候選人劉櫂豪的得票率高出蔡英文26個百分點，花蓮選區立委候選人蕭美琴比蔡英文得票多出17個百分點，其餘像是高雄市第4選區林岱樺、台中市第7選區何欣純等人，本身都強過蔡英文。</p>

    <!-- chart-1 -->
    <div class="article__chart">
      <div class="article__chart-caption">比蔡英文強的前五位區域立委</div>
      <div class="article__chart-figure article-2__chart-figure-1">
        <SvgSymbol use="#article-2-chart-1"/>
        <noscript>
          <table>
            <thead>
              <tr>
                <th>得票率高於蔡英文的地區</th><th>候選人</th><th>差距比例</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>台東縣選舉區</td><td>劉櫂豪</td><td>-0.26</td>
              </tr>
              <tr>
                <td>花蓮縣選舉區</td><td>蕭美琴</td><td>-0.17</td>
              </tr>
              <tr>
                <td>高雄市第4選舉區</td><td>林岱樺</td><td>-0.07</td>
              </tr>
              <tr>
                <td>台中市第7選舉區</td><td>何欣純</td><td>-0.06</td>
              </tr>
              <tr>
                <td>新北市第2選舉區</td><td>林淑芬</td><td>-0.06</td>
              </tr>
            </tbody>
          </table>
        </noscript>
      </div>
      <div class="article__chart-annotation"><!--
      --><span>資料來源：內政部、中選會</span><!--
      --><span>本文自行彙整</span>
      </div>
      <div class="article__chart-extended">
        <a class="article__chart-extended-link article__chart-extended-link-dpp"
          :href="`${baseUrl}pdf/dpp-legislators.pdf`"
          target="_blank"
          title="檢視綠營強壯「小雞」"><!--
        --><SvgSymbol use="#pdf"/><!--
        --><span>檢視綠營強壯「小雞」</span>
        </a>
      </div>
    </div>

    <p class="article__paragraph">至於民進黨最弱「小雞」是苗栗第1選區，比蔡英文在該選區的得票率低了15個百分點，其次為彰化縣第1選區、彰化縣第3選區，相較蔡英文在該選區的得票，皆低了13個百分點。</p>
    <p class="article__paragraph">國民黨方面，73個立委選區裡，扣除1個選區沒有提名，朱立倫僅在7個選區得票率高於國民黨區域候選人，其餘65個選區皆呈現「小雞」得票率較高的情況，國民黨最後只獲得20席區域立委，這意味著朱立倫屬於偏弱勢的「母雞」，立委候選人只能自己打拚，隨人顧性命。</p>
    <p class="article__paragraph">能鞏固自己選區的國民黨最強「小雞」，首先是彰化縣第1選區的王惠美，得票率比朱立倫高出28個百分點；其次是南投縣第2選區的許淑華，得票率贏過 25個百分點，其餘包括南投縣的馬文君、嘉義縣林江釧和台中市江啟臣，也都展現個人實力。</p>

    <!-- chart-2 -->
    <div class="article__chart">
      <div class="article__chart-caption">比朱立倫強的前五位區域立委</div>
      <div class="article__chart-figure article-2__chart-figure-2">
        <SvgSymbol use="#article-2-chart-2"/>
        <noscript>
          <table>
            <thead>
              <tr>
                <td>得票率高於朱立倫的選區</td><td>候選人</td><td>差距比例</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>彰化縣第1選舉區</td><td>王惠美</td><td>-0.28</td>
              </tr>
              <tr>
                <td>南投縣第2選舉區</td><td>許淑華</td><td>-0.25</td>
              </tr>
              <tr>
                <td>南投縣第1選舉區</td><td>馬文君</td><td>-0.22</td>
              </tr>
              <tr>
                <td>嘉義縣第1選舉區</td><td>林江釧</td><td>-0.21</td>
              </tr>
              <tr>
                <td>台中市第8選舉區</td><td>江啟臣</td><td>-0.20</td>
              </tr>
            </tbody>
          </table>
        </noscript>
      </div>
      <div class="article__chart-annotation"><!--
      --><span>資料來源：內政部、中選會</span><!--
      --><span>本文自行彙整</span>
      </div>
      <div class="article__chart-extended">
        <a class="article__chart-extended-link article__chart-extended-link-kmt"
          :href="`${baseUrl}pdf/kmt-legislators.pdf`"
          target="_blank"
          title="檢視藍營強壯「小雞」"><!--
        --><SvgSymbol use="#pdf"/><!--
        --><span>檢視藍營強壯「小雞」</span>
        </a>
      </div>
    </div>

    <p class="article__paragraph">國民黨最弱「小雞」出現在金門縣選區，得票率比朱立倫得票率少了21個百分點；其次是屏東縣第3選區、花蓮、台東。</p>

    <h3 class="article__paragraph-title">總統票和政黨票 未出現分裂投票</h3>
    <p class="article__paragraph">除了區域立委選票外，不分區得票率反映出政黨在一個地區的支持度，政黨票多寡，代表政黨在該選區基本盤。資料分析顯示，73個立委選區中，總統票和政黨票的分裂投票狀況並不明顯。</p>
    <p class="article__paragraph">因為朱立倫、蔡英文各自獲得的「總統票得票率」與所屬政黨的「政黨票得票率」，相關係數皆趨近於1，屬於 <Dictionary word="高度相關" meaning="高度相關，一般研究認為，相關係數0.3以下為低相關，0.3~0.7為中等相關，0.7以上為高度相關。"/> ；換言之，「母雞帶小雞」效應，在不分區立委選戰中，兩者幾乎完全連動，具有影響力。</p>
    <p class="article__paragraph">雖然兩者連動，但少部分選區的總統得票率高出不分區得票率較多，代表總統候選人在這些地區的個人特質，高於其政黨支持度。民進黨有此現象的區域集中在雲林縣、嘉義縣、台中市等中台灣一帶；國民黨則集中在台北市、新北市，以雙北地區為主。</p>
    <p class="article__paragraph">由於總統、區域立委和政黨得率，都有一定程度相關，因此，一隻好的母雞能帶領政黨立委候選人進入國會殿堂，若是遇上不好的母雞，若不想住在選區套房裡，只好自己發奮圖強。</p>

  </div>
</template>

<script>
import Dictionary from '@/components/Dictionary'

export default {
  name: 'Article2',
  components: {
    Dictionary
  },
  inject: [ 'baseUrl' ]
}
</script>

<style lang="scss">
.article-2 {
  table {
    width: 100%;

    th, td {
      padding: 0.5em 1em;
      text-align: left;
      border: 1px solid gray;

      &:first-child {
        width: 45%;
        text-align: left;
      }
      &:nth-child(n+2) {
        width: 35%;
        text-align: center;
      }
      &:nth-child(n+3) {
        width: 25%;
        text-align: right;
      }
    }
  }

  &__chart-figure {
    &-1 {
      @include use-fixed-ratio(736, 304);
    }

    &-2 {
      @include use-fixed-ratio(736, 304);
    }

    .svg-symble {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
